// extracted by mini-css-extract-plugin
export var highlightFade = "_3h-4";
export var highlighted = "_3h-3";
export var table = "_3h-1";
export var tableContainer = "_3h-0";
export var totalsRow = "_3h-2";